import templateDefaultProps from '../../../../constants/templateDefaultProps';
import latestReleases from '../latestReleases';
import { sectionsDict, getEvaluatedSet } from './getSectionsData';

export default (data) => {
  const { leftPane, version } = data;
  if (leftPane && (!version || version !== latestReleases.userPreferences)) {
    const { unUsed, used } = leftPane;
    const evaluatedSet = getEvaluatedSet(unUsed, used);
    if (evaluatedSet.size) {
      evaluatedSet.forEach((title) => {
        unUsed.push(sectionsDict[title]);
      });

      if (data.templateProperty) {
        return {
          ...data,
          leftPane: {
            ...leftPane,
            unUsed,
          },
          templateProperty: {
            ...data.templateProperty,
            default: { ...templateDefaultProps.RESUME },
          },
          version: latestReleases.userPreferences,
        };
      }

      return {
        ...data,
        leftPane: {
          ...leftPane,
          unUsed,
        },
        templateProperty: {
          default: { ...templateDefaultProps.RESUME },
          updated: {},
        },
        version: latestReleases.userPreferences,
      };
    }
  }

  if (data.templateProperty) {
    return {
      ...data,
      templateProperty: {
        ...data.templateProperty,
        default: { ...templateDefaultProps.RESUME },
      },
    };
  }

  return {
    ...data,
    templateProperty: {
      default: { ...templateDefaultProps.RESUME },
      updated: {},
    },
  };
};
